import { useQuery } from '@tanstack/react-query';
import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';

export type RiskStatistic = {
  risk: string;
  risk_key: string;
  note_count: number;
};

// eslint-disable-next-line import/prefer-default-export
export function useRiskStatistics(queryParams: string) {
  return useQuery<RiskStatistic[]>({
    queryKey: [APIKey.RISK_STATISTICS, queryParams],
    queryFn: () => baseFetcher(`${apiRoutes.riskStatistics()}?${queryParams}`),
  });
}
